//
// CategoryValueInfo.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../../models/BIRDModel";
import "@sas-dvr/ltjs-commons/models/data/DataValue";

var CategoryValueInfo = createModule("BIRD::CategoryValueInfo", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        label: 7,
        totalCount: 1,
        value: 1,
        selected: 2,
    },
    ,
    ,
    ,
    ,
    ,
]);
export default CategoryValueInfo;
